<template>
  <!-- don't forget change viewBox and fill params -->
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" class="play-icon" viewBox="0 0 152 152">
    <!-- begin -->

    <circle class="play-circle-01" fill="none" :stroke="color" :stroke-width="stroke" stroke-dasharray="343 343" cx="76" cy="76" r="72.7"/>
    <circle class="play-circle-02" fill="none" :stroke="color" :stroke-width="stroke" stroke-dasharray="309 309" cx="76" cy="76" r="65.5"/>

    <!-- end -->
  </svg>
</template>

<script>
  export default {
    props: {
      width: { type: String },
      height: { type: String },
      color: { type: String },
      stroke: { type: String }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/icons/play.vue